export default __webpack_public_path__ + "static/media/Chile.f477fc62.svg";